  enum ValidationOptionsEnum {
    Regex = 'regex',
    Email = 'email',
    List = 'list',
    Phone = 'phone',
    Length = 'length',
    Range = 'range'
  }
  
  export default ValidationOptionsEnum;